import { CasinoGame, CoinFlipRoom } from "@/services/types"
import { Module } from "vuex"
import {
  AsyncState,
  CoinFlipRoomsAsMap,
  CoinFlipState,
  RootState,
} from "@/store/types"
import { createAsyncAction } from "../utils/createAsyncAction"
import {
  getRoomsApi,
  joinRoom,
  leaveRoom,
  inviteBot,
} from "../api/coinFlip/rooms"
import { getCasinoGame } from "../api/coinFlip/casinoGame"

const coinFlipStore: Module<CoinFlipState, RootState> = {
  namespaced: true,
  state: () => ({
    rooms: {
      data: new Map(),
      loading: true,
    } as AsyncState<CoinFlipRoomsAsMap>,
    roomToJoin: null as CoinFlipRoom | null,
    roomToView: null as CoinFlipRoom | null,
    casinoGame: {
      data: {},
      loading: true,
    } as AsyncState<CasinoGame>,
    inviteBot: {
      data: {},
      loading: false,
    } as AsyncState<any>,
  }),
  getters: {
    rooms: (state) => state.rooms,
    roomToJoin: (state) => state.roomToJoin,
    roomToView: (state) => state.roomToView,
    casinoGame: (state) => state.casinoGame.data,
    inviteBot: (state) => state.inviteBot,
  },
  mutations: {
    SET_ASYNC_STATE<K extends keyof CoinFlipState>(
      state: CoinFlipState,
      {
        key,
        patch,
      }: {
        key: K
        patch: Partial<CoinFlipState[K]>
      }
    ) {
      state[key] = {
        ...state[key],
        ...patch,
      }
    },
    CLEAR_ROOMS(state) {
      state.rooms.data = new Map()
    },
    ADD_ROOM(state, room: CoinFlipRoom) {
      state.rooms.data.set(room.id, room)
    },
    DELETE_ROOM(state, room: CoinFlipRoom) {
      state.rooms.data?.delete(room.id)
    },
    // UPDATE_ROOM(state, updatedRoom: CoinFlipRoom) {
    //   state.rooms.data?.set(updatedRoom.id, updatedRoom)
    // },
    UPDATE_ROOM(state, updatedRoom: CoinFlipRoom) {
      if (!state.rooms.data.has(updatedRoom.id)) {
        state.rooms.data.set(updatedRoom.id, updatedRoom)
      } else {
        state.rooms.data?.set(updatedRoom.id, updatedRoom)
      }
    },
    SET_ROOM_TO_JOIN(state, room: CoinFlipRoom | null) {
      state.roomToJoin = room
    },
    SET_ROOM_TO_VIEW(state, room: CoinFlipRoom | null) {
      state.roomToView = room
    },
    CLEAR_INVITE_BOT(state) {
      state.inviteBot = {
        data: {},
        loading: false,
      }
    },
  },
  actions: {
    getCasinoGame: createAsyncAction(getCasinoGame, "casinoGame"),
    getRooms: createAsyncAction(getRoomsApi, "rooms"),
    joinRoom: createAsyncAction(joinRoom, "room"),
    leaveRoom: createAsyncAction(leaveRoom, "room"),
    inviteBot: createAsyncAction(inviteBot, "inviteBot"),
    addRoom({ commit }, room: CoinFlipRoom) {
      commit("ADD_ROOM", room)
    },
    deleteRoom({ commit }, room: CoinFlipRoom) {
      commit("DELETE_ROOM", room)
    },
    setRoomToJoin({ commit }, room: CoinFlipRoom | null) {
      commit("SET_ROOM_TO_JOIN", room)
    },
    setRoomToView({ commit }, room: CoinFlipRoom | null) {
      commit("SET_ROOM_TO_VIEW", room)
      commit("CLEAR_INVITE_BOT", null)
    },
  },
}

export default coinFlipStore
